import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectsSobha } from "../../../../data/projects/sobha/data";
import { projectstarc } from "../../../../data/projects/Tarc/data";
import { projectsTrinity } from "../../../../data/projects/Trinity/data";

export const TrinityPlazzos = () => {
  const { 
    palazzos: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar
    }
  } = projectsTrinity;

  return (
    <>
      <Helmet>
        <title>DLF  Gurgaon - Ultra-Luxury Apartments for Elite Living</title>
        <meta
          name="description"
          content="Discover DLF  Gurgaon – an exclusive ultra-luxury residential project featuring spacious apartments, modern amenities, and a prime location."
        />
        <meta name="robots" content="index, follow" />
        <meta
          name="keywords"
          content="DLF The Arbour, Sector 63 Gurgaon, DLF The Arbour Gurgaon, DLF luxury apartments, premium homes in Gurgaon, DLF new launch"
        />
        <link rel="canonical" href="https://propertystation.in/dlf-arbour-sector-63-gurugram" />
      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
      </div>
    </>
  );
};
